/*
* Verify Component: verify step in login and register and displays after the user change it's phone number.
* You can use these classes to target the elements in the component.
*/

salla-verify {
  display: block;
}

.s-verify {
  &-host{
    
  }
  &-message {

  }
  &-label {

  }
  &-codes {

  }
  &-input {
    // Hide number input arrows
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type=number] {
      -moz-appearance: textfield;
    }
  }
  &-footer {

  }
  &-submit {

  }
  &-resend-message {

  }
  &-timer {

  }
  &-resend {

  }
  &-back {
    
  }
}
